export default __webpack_public_path__ + "static/media/Belt of Ben Morgh.62c29371.jpg";